import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import _ from 'underscore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

import conversionTracker from '../../utils/conversionTracker';
import { safeCredentials, handleErrors } from '../../utils/fetchHelpers';

import './StepThree.scss';

class StepThree extends React.Component {
  state = {
    redirectingToPayInFull: false,
    redirectingToPayByInstallment: false,
    tuitionAgreementChecked: false,
    installmentAgreementChecked: false,
  };

  clickToPayByInstallment = () => {
    this.setState({redirectingToPayByInstallment: true});

    conversionTracker(window, 'InitiatePayment', {
      step: 4,
      value: Math.round(this.props.calculateTotalPrice(true)),
      nanomajor_long_symbol: this.props.selectedTrack.attributes.long_symbol,
      variant: this.props.selectedProgram,
      first_name: this.props.first_name,
      last_name: this.props.last_name,
      email: this.props.email,
      start_date: this.props.start_date,
      content_category: 'nanomajors',
      payment_source: 'stripe_installments',
      terms_of_service_agreement_checked: true,
      privacy_policy_agreement_checked: true,
      discount_code: this.props.discount_code,
    });

    var stripe = Stripe(process.env.STRIPE_PUBLISHABLE_KEY);

    let plan;

    plan = _.find(this.props.selectedTrack.relationships.price_options.data, option => option.attributes.name === this.props.selectedProgram).attributes.installment_plan_id;

    fetch('/api/v2/orders', safeCredentials({
      method: 'POST',
      body: JSON.stringify({
        order: {
          first_name: this.props.first_name,
          last_name: this.props.last_name,
          email: this.props.email,
          long_symbol: this.props.selectedTrack.attributes.long_symbol,
          variant: this.props.selectedProgram,
          start_date: this.props.start_date,
          category: 'stripe_installments',
          discount_code: this.props.discount_code,
        },
        price: plan,
        url: process.env.URL,
        value: this.props.calculateTotalPrice(true),
        discount_code: this.props.discount_code,
      }),
    }))
    .then(res => res.json())
    .then((res) => {
      return stripe.redirectToCheckout({sessionId: res.checkout_session_id});
    })
  }

  clickToPayInFull = () => {
    this.setState({redirectingToPayInFull: true});

    conversionTracker(window, 'InitiatePayment', {
      step: 4,
      value: this.props.calculateTotalPrice(),
      nanomajor_long_symbol: this.props.selectedTrack.attributes.long_symbol,
      variant: this.props.selectedProgram,
      first_name: this.props.first_name,
      last_name: this.props.last_name,
      email: this.props.email,
      start_date: this.props.start_date,
      content_category: 'nanomajors',
      payment_source: 'stripe_one_time',
      terms_of_service_agreement_checked: true,
      privacy_policy_agreement_checked: true,
      discount_code: this.props.discount_code,
    });

    var stripe = Stripe(process.env.STRIPE_PUBLISHABLE_KEY);

    let plan;

    plan = _.find(this.props.selectedTrack.relationships.price_options.data, option => option.attributes.name === this.props.selectedProgram).attributes.stripe_one_time_plan_id;

    fetch('/api/v2/orders', safeCredentials({
      method: 'POST',
      body: JSON.stringify({
        order: {
          first_name: this.props.first_name,
          last_name: this.props.last_name,
          email: this.props.email,
          long_symbol: this.props.selectedTrack.attributes.long_symbol,
          variant: this.props.selectedProgram,
          start_date: this.props.start_date,
          category: 'stripe_one_time',
          discount_code: this.props.discount_code,
        },
        price: plan,
        url: process.env.URL,
        value: this.props.calculateTotalPrice(),
        discount_code: this.props.discount_code,
      }),
    }))
    .then(res => res.json())
    .then((res) => {
      return stripe.redirectToCheckout({sessionId: res.checkout_session_id});
    })
  }

  handleTuitionAgreementChange = (event) => {
    this.setState({ tuitionAgreementChecked: event.target.checked });
  };

  handleInstallmentAgreementChange = (event) => {
    this.setState({ installmentAgreementChecked: event.target.checked });
  };

  render() {
    const selection = this.props.selectedTrack;
    const isButtonDisabled = !this.state.tuitionAgreementChecked || !this.state.installmentAgreementChecked;

    return (
      <div className='container' id="step-three">
        <div className="row">
          <div className='col page-content'>
            <div className='reviewCourses'>
              <h4>Invest In Yourself</h4>

              <div className="pt-1 pb-5">
                <div className="d-flex flex-row">
                  <div className='nmLogo' style={{ backgroundColor: selection.attributes.color, color: 'white' }}>
                    {selection.attributes.short_symbol}
                  </div>
                  <div className='info'>
                    <h5>{selection.attributes.long_name}</h5>
                    <p style={{ textTransform: 'capitalize' }}>{this.props.selectedProgram} Program</p>
                    <p>{this.props.first_name} {this.props.last_name} ({this.props.email})</p>
                    <p>Begins on {this.props.start_date}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className='reviewCourses'>
              <h4>Pay in full</h4>
              <p>
                Tuition – ${this.props.calculateTotalPrice()} USD.
                <br />
                Most students choose to pay in full.
              </p>

              <div className="pt-3 pb-5 text-center">
                <RaisedButton
                  label="Pay"
                  backgroundColor="#1647fb"
                  labelColor="#fff"
                  className='payInFull'
                  onClick={this.clickToPayInFull}
                  role="link"
                />

                {this.state.redirectingToPayInFull && <div className="d-flex justify-content-center">
                  <FontAwesomeIcon icon={faSpinner} spin size="2x" className="mx-1"
                    hidden={this.props.hidden || false}
                    style={{ color: this.props.color || '#4caf50' }}
                  />
                  <small className="my-auto"><b>Redirecting to Payment Processing page...</b></small>
                </div>}

                <div className="pt-4">
                  <img width="35px" height="auto" className="ml-2 mr-2" src="/images/cards/visa.png"></img>
                  <img width="35px" height="auto" className="ml-2 mr-2" src="/images/cards/mastercard2.png"></img>
                  <img width="35px" height="auto" className="ml-2 mr-2" src="/images/cards/american_express.png"></img>
                  <img width="35px" height="auto" className="ml-2 mr-2" src="/images/cards/discover.png"></img>
                  <img width="35px" height="auto" className="ml-2 mr-2" src="/images/cards/jcb.png"></img>
                  <img width="35px" height="auto" className="ml-2 mr-2" src="/images/cards/wechatpay.png"></img>
                </div>
              </div>
            </div>

            <div className='reviewCourses'>
              <h4>Pay in installments</h4>

              <p>
                ${this.props.calculateTotalPrice(true)} USD per month for 12 months.
                <br />
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="tuitionAgreement" required onChange={this.handleTuitionAgreementChange} />
                  <label className="form-check-label" htmlFor="tuitionAgreement">
                    You agree to pay all tuition (${Math.round(this.props.calculateTotalPrice(true) * 12 * 100) / 100} USD) in the next 12 months.
                  </label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="installmentAgreement" required onChange={this.handleInstallmentAgreementChange} />
                  <label className="form-check-label" htmlFor="installmentAgreement">
                    You agree to pay all 12 installments if you complete all the courses before the next 12 months.
                  </label>
                </div>
              </p>

              <div className="pt-1 pb-2 text-center">
                <RaisedButton
                  label="Pay in 12 installments"
                  backgroundColor="#212121"
                  labelColor="#fff"
                  onClick={isButtonDisabled ? () => alert('Please check the payment agreements') : this.clickToPayByInstallment}
                  role="link"
                  disabled={isButtonDisabled}
                />
              </div>

              {this.state.redirectingToPayByInstallment && <div className="d-flex justify-content-center">
                <FontAwesomeIcon icon={faSpinner} spin size="2x" className="mx-1"
                  hidden={this.props.hidden || false}
                  style={{ color: this.props.color || '#4caf50' }}
                />
                <small className="my-auto"><b>Redirecting to Payment Processing page...</b></small>
              </div>}

              <p className="text-center"><small><b>This is not a monthly subscription. You're required to pay all tuition (${Math.round(this.props.calculateTotalPrice(true) * 12 * 100) / 100} USD) in the next 12 months.</b></small></p>
            </div>

            <div className='paymentDisclaimer d-flex flex-column align-items-center text-center'>
              <small>
                Secure payment handled by <a href="https://stripe.com/" target="_blank" rel="noopener noreferrer">Stripe</a>. We don't store your credit card information on our site.
              </small>
              <small>
                By making your payment for our courses, you agree to the terms of our <a href="/legal/privacy" target="_blank">Privacy Policy</a>, and <a href="/legal/terms" target="_blank">Terms of Service</a>.
              </small>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StepThree;
